export type ResponseStatusCodes = 200 | 400 | 401 | 403 | 404 | 422 | 500
export const responseCodeMessages: Record<ResponseStatusCodes, string> = {
    200: "ok",
    400: "Bad request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not found",
    422: "Validation error",
    500: "Internal server error",
}

export enum StatusCodes {
    LOGIN_EMAILNOTEXISTS = "err_email_not_exists",
    LOGIN_WRONGPASSWORD = "err_wrong_password",
    VERIFICATION_REQUIRED = "err_verification_required",
    VERIFICATION_FAILED = "err_verification_failed",
    REGISTER_EMAILINUSE = "err_email_in_use",
    COMPANY_NAME_AND_IC_ALREADY_USED = "err_company_name_and_ic_already_used",
    SUPPLIER_IC_OR_DIC_ALREADY_USED = "err_supplier_ic_or_dic_already_used",
}
